jQuery(document).ready(function($) {
    $('.post-slider').each(function () {
        var $section = $(this);
        $section.find('.post-slider-container').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: true,
            prevArrow: $section.find('.post-slider-prev'),
            nextArrow: $section.find('.post-slider-next'),
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    });
});
